var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar"},[_c('img',{attrs:{"id":"logo","src":require("../assets/logo.png")}}),_c('h1',[_vm._v(_vm._s(_vm.$root.headline))]),_c('h2',[_vm._v(_vm._s(_vm.$root.subheadline))])])}
var staticRenderFns = []

export { render, staticRenderFns }